class NavMenu {
    constructor() {
        this.navBar = document.querySelector('.navigation-bar');
        this.menuBtn = this.navBar.querySelector('[data-role="menu button"]');
        this.menuWrp = this.navBar.querySelector('[data-role="navigation menu"]');
        this.menuCloseBg = this.navBar.querySelector('.nav__menu__overlay')
        this.init();
    }

    openMenu() {
        this.menuBtn.classList.add("st-open");
        this.menuBtn.setAttribute("menu-state", "open");

        this.menuWrp.classList.add("st-visible");
        this.menuWrp.setAttribute("menu-state", "open");

        this.toggleMenuCloseBg();
    }

    closeMenu() {
        this.menuBtn.classList.remove("st-open");
        this.menuBtn.setAttribute("menu-state", "closed");

        this.menuWrp.classList.remove("st-visible");
        this.menuWrp.setAttribute("menu-state", "closed");

        this.toggleMenuCloseBg();
    }

    toggleMenu() {
        if (this.menuBtn.getAttribute("menu-state") === "closed") {
            this.openMenu();
        } else if (this.menuBtn.getAttribute("menu-state") === "open") {
            this.closeMenu();
        }
    }

    toggleMenuCloseBg() {
        if (this.menuBtn.getAttribute("menu-state") === "closed") {
            this.menuCloseBg.classList.remove('st-active')
        } else if (this.menuBtn.getAttribute("menu-state") === "open") {
            this.menuCloseBg.classList.add('st-active')
        }
    }

    init() {
        const breakpoint = window.matchMedia("(max-width: 991px)");

        this.menuBtn.addEventListener("click", () => {
            this.toggleMenu();
        });
        this.menuCloseBg.addEventListener("click", () => {
            this.closeMenu();
        });


        const breakpointChecker = () => {
            if (breakpoint.matches) {
                this.menuWrp.classList.add("mobile-menu");
                this.menuWrp.setAttribute("menu-state", "closed");
                this.menuBtn.setAttribute("menu-state", "closed");
            } else {
                this.menuWrp.classList.remove("mobile-menu");
                this.closeMenu();
                this.menuBtn.removeAttribute("menu-state");
                this.menuWrp.removeAttribute("menu-state");
            }
        };

        breakpoint.addListener(breakpointChecker);
        breakpointChecker();
    }
}

export default NavMenu